import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

import './style.less';

const HeaderToggleFiltersButton = ({ children, className, ...ButtonProps }) => (
  <Button
    type="link"
    className={`filters-button ${className}`}
    {...ButtonProps}
  >
    {children}
  </Button>
);

HeaderToggleFiltersButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

export default HeaderToggleFiltersButton;
